<template>
  <div ref="appContent" class="app-body">
      <el-form ref="queryForm" class="query-form" :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="客户：">
          <el-input type="text" v-model="dataForm.customerName" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="进出口发票号：">
          <el-input type="text" v-model="dataForm.virtualCode" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="收款情况：">
          <el-select v-model="dataForm.payType" size="mini" >
            <el-option label="请选择" value=""></el-option>
            <el-option label="已收款" value="payed"></el-option>
            <el-option label="未收款" value="unpaid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" size="mini">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="showBatchSaveDialog()" size="mini" type="primary">批量收款</el-button>
        </el-form-item>
      </el-form>
      <SweetTable ref="table" url="/trade/receivelog/receivable/page" :query-form="dataForm" :cell-style-handler="cellStyleHandler"
                  :summaries-column="['totalAmount','receiveAmount','waitPayAmount']"
                  :before-table-binding="beforeTableBinding">
        <el-table-column prop="receiptCode" label="进出口发票号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="customerName" label="客户" header-align="center" align="center" :formatter="$c.companyNameFormatter"></el-table-column>
        <el-table-column prop="currency" label="货币" header-align="center" align="center"  width="120"></el-table-column>
        <el-table-column prop="codeAmount" label="出口发票金额" header-align="center" align="center" width="160"></el-table-column>
        <el-table-column prop="totalAmount" label="发票金额" header-align="center" align="center" width="160"></el-table-column>
        <el-table-column prop="batchAmount" label="收款金额" header-align="center" align="center" width="160"></el-table-column>
        <el-table-column prop="receiveAmount" label="实收金额" header-align="center" align="center" width="160"></el-table-column>
        <el-table-column prop="waitPayAmount" label="待收款" header-align="center" align="center" width="160"></el-table-column>
        <el-table-column prop="operateDate" label="收款日期" header-align="center" align="center"  width="160"></el-table-column>
        <el-table-column prop="receiveRemark" label="收款备注" header-align="center" align="center"></el-table-column>
        <el-table-column label="操作" header-align="center" align="center"  width="160" fixed="right">
          <template #default="{row}">
            <el-button type="text" size="mini" @click="showLogDialog(row)">查看明细</el-button>
            <el-button type="text" size="mini" @click="showAmountDialog(row)">金额设置</el-button>
          </template>
        </el-table-column>
      </SweetTable>
      <!-- 弹窗, 新增 / 修改 -->
      <log-dialog ref="LogDialog"></log-dialog>
      <batch-save-dialog ref="BatchSaveDialog" @complete="getDataList"></batch-save-dialog>
      <amount-dialog ref="AmountDialog" @change="getDataList"></amount-dialog>
  </div>
</template>

<script>
import AmountDialog from '@/views/modules/fund/receive/amount-dialog.vue'
import BigNumber from 'bignumber.js'
import LogDialog from '@/views/modules/fund/receive/log-dialog'
import BatchSaveDialog from '@/views/modules/fund/receive/batch-save-dialog'
import SweetTable from '@/mixins/SweetTable'

export default {
  mixins: [SweetTable],
  components: {
    LogDialog, BatchSaveDialog, AmountDialog
  },
  data () {
    return {

      maxTableHeight: 100,
      dataForm: {
        customerName: '',
        virtualCode: '',
        accountId: '',
        payType:''
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.maxTableHeight =
          (this.$refs.appContent.clientHeight -
              this.$refs.queryForm.$el.clientHeight -
              55)
    })
  },
  methods: {
    showAmountDialog (row) {
      this.$refs.AmountDialog.init(row)
    },
    showBatchSaveDialog () {
      if (this.dataListSelections.length === 0) {
        return this.$message.error('请选择应收账款')
      }
      this.$refs.BatchSaveDialog.dataList = this.dataListSelections.map(item => {
        return {
          ...item,
          amount: item.waitPayAmount
        }
      })
      this.$refs.BatchSaveDialog.init()
    },
    showLogDialog (row) {
      this.$refs.LogDialog.init(row.receiptCode)
    },
    cellStyleHandler ({ row, column, rowIndex, columnIndex }) {
      let style
      if (columnIndex > 3) {
        if (row.waitPayAmount == 0) {
          style = {
            color: '#67C23A'
          }
        } else if (row.waitPayAmount < row.totalAmount) {
          style = {
            color: '#d565e4'
          }
        } else {
          style = {
            color: '#F56C6C',
          }
        }
      }
      return style
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.waitPayAmount = new BigNumber(row.totalAmount).minus(row.receiveAmount).toFixed(4)
      })
    }
  },

}
</script>
